<!--Section Title -->
<a>
  <span class="circle z-depth-1-half" [class.success-color]="trackAndTraceItem.isActive" [class.danger-color]="trackAndTraceItem.isError">
    <jhi-bary-icon [icon]="trackAndTraceItem.icon" [faDirective]="FaDirectiveEnum.FAS" aria-hidden="true"></jhi-bary-icon>
  </span>
</a>
<!-- Section Description -->
<div
  class="step-content z-depth-1 ml-xl-0 p-4"
  [class.border]="trackAndTraceItem.isActive || trackAndTraceItem.isError"
  [class.border-success]="trackAndTraceItem.isActive"
  [class.border-danger]="trackAndTraceItem.isError"
>
  <h4 class="font-weight-bold" [jhiTranslate]="getTitleKey()"></h4>
  <p class="text-muted mt-3" *ngIf="trackAndTraceItem.stepDate">
    <jhi-bary-icon icon="clock" [faDirective]="FaDirectiveEnum.FAR" aria-hidden="true"></jhi-bary-icon>
    {{ trackAndTraceItem.stepDate.toDate() | date: 'short' }}
  </p>
  <p class="mb-0" *ngIf="trackAndTraceItem.isActive || trackAndTraceItem.isError" [translate]="getTextKey()" [translateParams]="{ shopName: companyName, mail: savMail }"></p>
</div>
